import React, { useState, useEffect} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { UserContext } from "./lib/UserContext";
import Home from "./pages/Home";
import Login from "./pages/Login";
import KeepInTouch from "./pages/KeepInTouch";
import Values from "./pages/Values";
import Questions from "./pages/Questions";
import Glyph from "./pages/Glyph";
import Callback from "./pages/Callback";
import Profile from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import PremiumNft from "./pages/PremiumNft";

function App() {
  const [user, setUser] = useState<any>({});

  return (
    <UserContext.Provider value={[user, setUser]}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/keep-in-touch" element={<KeepInTouch />} />
          <Route path="/values" element={<Values />} />
          <Route path="/questions" element={<Questions />} />
          <Route path="/glyph" element={<Glyph />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/editProfile" element={<EditProfile />} />
          <Route path="/premium-nft" element={<PremiumNft />} />
          <Route path="/callback" element={<Callback />} />
        </Routes>
      </Router>
    </UserContext.Provider>
  );
}

export default App;
